// removed by extract-text-webpack-plugin
module.exports = {"wrap":"_1yd8q","wrapChecked":"dOWur _1yd8q","dot":"_2pz-W","dotChecked":"LLIBN _2pz-W"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Toggle.css
// module id = 811
// module chunks = 0